<template>
    <div style="width:100%;heigh:100%;">
        <div class="table_searchbar">
            <el-row >
                <el-col :span="span">
                    <div class="" @keydown.enter="btnSearch()">
                    <span class="title">汇总状态：</span>
                        <el-select style="max-width:180px" size="small"  v-model="searchForm.status" placeholder="汇总状态"  >
                            <el-option  key="0" label="未汇总" value="0"></el-option>
                            <el-option  key="1" label="已汇总" value="1"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <!-- <el-col :span="span">
                    <div class="" @keydown.enter="btnSearch()">
                    <span class="title">仓库：</span>
                        <el-select size="small" style="max-width:180px;" v-model="searchForm.warehouseId" placeholder="选择仓库" filterable >
                            <el-option v-for="item in warehouseList" :key="item.value" :label="item.warehouseName" :value="item.id">
                            </el-option>
                        </el-select>    
                    </div>
                </el-col> -->
                <el-col :span="span">
                    <div class="">
                        <span class="title">月份：</span>
                        <el-date-picker style="width:180px;"
                            @change='dateChange'
                            v-model="searchForm.date"
                            value-format='yyyy-MM'
                            type="monthrange"
                            range-separator="-"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份">
                        </el-date-picker>                  
                    </div>
                </el-col>
                <el-col :span="(24-2*span)">
                    <div style="text-align:right">
                        <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
                        <el-button size="mini" icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-table :data="tableData" stripe style="width: 100%" class="deviceTable">
            <el-table-column prop="yearMonth" label="月份" :formatter="parseMonth"  min-width="110"></el-table-column>
            <el-table-column prop="status" label="汇总状态" :formatter="parseStatus" min-width="110">
                <template slot-scope="scope">
                    <span :style="{color:parseStyle(scope.row)}">{{parseStatus(scope.row)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="gmtCreate" label="创建时间" :formatter="parseCreatDate" min-width="110"></el-table-column>
            <el-table-column prop="gmtModified" label="修改时间" :formatter="parseModifiedDate"  min-width="110"></el-table-column>
            <el-table-column label="操作" fixed="right" width="140">
                <template slot-scope="scope">
                    <el-button v-if="permission.btn_summary_get" type="text" @click="showViewDialog(scope.row)" size="small">查看</el-button>
                    <el-button v-if="permission.btn_summary_summary&&!scope.row.status" type="text" @click="submitSummary(scope.row)" size="small">汇总</el-button>
                    <el-button v-if="permission.btn_summary_cancel&&scope.row.cancelPermission" type="text" @click="cancelSummary(scope.row)" size="small">取消汇总</el-button>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="materialName" label="物料名称"  min-width="110"></el-table-column>
            <el-table-column prop="productionBatch" label="物料批次"  min-width="110"></el-table-column>
            <el-table-column prop="itemAmount" label="仓库数量"  min-width="110"></el-table-column>
            <el-table-column prop="availableAmount" label="可用数量"  min-width="110"></el-table-column> -->
        </el-table>
        <div class="page" v-if="tableData.length > 0">
            <div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
            <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                <el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage">
                </el-pagination>
            </div>
        </div>
       
        <!-- 查看点检点检开始 -->
        <el-dialog title="出入库详情" @close="cancelViewDialog"  :visible.sync="viewDialogVisible" :width="span==5?'48%':'78%'" center :close-on-click-modal="false">
            <!-- <el-table-column prop="mgtCreate" label="创建时间" :formatter="parseCreatDate" min-width="80" show-overflow-tooltip></el-table-column> -->
            <el-row>
                <el-col :span="6">
                 <div class="" >
                    <span class="title">汇总月份：</span>
                    <span>{{repertTime}}</span>
                    </div>
                </el-col>
            </el-row>
            <el-table :data="detailList"  style="width: 100%;margin-bottom:10px; max-height:460px; height:auto; overflow-y: scroll" >
                <el-table-column label="序号" min-width="60">
                    <template slot-scope="scope">
                        <span>{{scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="warehouseName" label="仓库名称" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="materialCode" label="物料编码" min-width="80" show-overflow-tooltip></el-table-column>  
                <el-table-column prop="productionBatch" label="物料批次" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="amountAtBeginning" label="月初数量"  min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="amountAtEnd" label="月末数量"  min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column label="入库数量" prop="totalStockInAmount" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column label="出库数量" prop="totalStockOutAmount" min-width="80" show-overflow-tooltip></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelViewDialog" type="primary">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 新增点检配置结束 --> 
    </div>
</template>

<script>

export default {
    name: 'MonthlySummary',
	data () {
        return {
            fristLoad:false,
            repertTime:null,
            loading:false,
            warehouseList:[],
            materialList:[],
            time:'&nbsp;',
            detailList:[
            ],
            levelOption:[],
            viewDialogVisible:false,
            editDialogVisible:false,
            W:false,
            btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
            searchFormTemp: '',//临时搜索数据
            searchForm:{
                status:null,
                startDate:null,
                endDate:null,
                date:null
            },
            addForm:{
                itemType: null,
                materialCode: '',
                specification:'',
                materialName: '',
                unitTypeId: null
            },
            viewForm : {
            },
            tableData:[
            ],
            tableCurrentPage:1,
            tableTotalPage:2,
            addDialogVisible:false,
            editDialogVisible:false,
            viewDialogVisible:false,
            data: {
				token: localStorage.getItem("token"),
            },
            permission:JSON.parse(localStorage.getItem("permission")) 
        }
    },
    mounted:function(){
        this.initTable();
        // this.loadMaterialList('')
        // this.loadTreeList()
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
        w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    deactivated:function(){
        console.log("deactivated");
    },
    methods:{
        parseStyle(rowData){
             let str = ''
            if(!rowData.status){
                str = 'red'
            }else{
                str = 'green'
            }
            return str
        },
        dateChange(ev){
            if(ev){
                this.searchForm.startDate = ev[0]
                this.searchForm.endDate = ev[1]
            }else{
                this.searchForm.startDate = null
                this.searchForm.endDate = null
            }
        },
        async loadTreeList(){
            let res = await this.$RequestUtil.getAsync({url: '/api/warehouseController/listFormatWarehouseByWarehouseId',params: {}})
            if(res.data.length>0){
                res.data.forEach(item=>{
                    let arr = item.formatWarehouseName.split('/')
                    let str = ''
                    if(arr.length==2){
                        str=arr[1]
                    }else{
                        arr.shift()
                        arr.shift()
                        str = arr.join('/')
                    }
                    item.warehouseName = str
                })
                log(res.data)
                this.warehouseList = res.data
            }
        },
        async loadMaterialList(code){
            if(code==null||code==undefined){
                code = ''
            }
            let res = await this.$RequestUtil.getAsync({url: '/api/select/listMaterialName',params: {code}})
            if(code ==''){
                this.materialList = res.data
            } 
            return res.data
        },
        async remoteMethod(query) {
            this.loading = true;
            let data = await this.loadMaterialList(query)
            this.loading = false
            this.materialList = data
        },
        submitSummary(rowData){
            this.$confirm('此操作将生成本月出入库记录, 汇总后本月可能无法进行出入库操作后，是否继续?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.get({
                    url: '/api/summary/summaryForOneMonth',
                    type:'sync',
                    params: {
                        summaryId:rowData.id
                    },
                    success: (res) => {
                        if(res.code != -1){
                            this.$message({
                                type: 'success',
                                message: '汇总成功!'
                            });
                            this.search(1);
                        }else{
                            this.$message.error(res.message||res.msg)
                        }
                    }
                })
            })
        },
        cancelSummary(rowData){
            this.$confirm('此操作将会取消汇总, 是否继续?', '提示', {
                cancelButtonClass: "btn-custom-cancel",
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$RequestUtil.get({
                    url: '/api/summary/cancelSummaryForOneMonth',
                    type:'sync',
                    params: {
                        summaryId:rowData.id
                    },
                    success: (res) => {
                        if(res.code != -1){
                            this.$message({
                                type: 'success',
                                message: '取消成功!'
                            });
                            this.search(1);
                        }else{
                            this.$message.error(res.message||res.msg)
                        }
                    }
                })
            })
            
        },
        cancelViewDialog(){
            this.viewDialogVisible = false
            this.detailList = []
        },
        btnSearch:function(){
            this.tableCurrentPage = 1;
            this.btnPressType = 1
            this.search();
        },
        clearSearch(){
            let form = this.searchForm;
            this.btnPressType = 2;
            form.status = null
           
            form.startDate = null
            form.endDate = null
            form.date = null	
        },
        search:function(){
            let temp;
            switch (this.btnPressType) {
              case 1:
                temp = commonUtils.cloneObj(this.searchForm);
                this.searchFormTemp = commonUtils.cloneObj(temp);
                break;
              case 0:
                temp ={
                    status :null,
                    warehouseId :null,
                    startDate :null,
                    endDate :null,
                    date :null,
                };
                break;
              case 2:
                temp = this.searchFormTemp;
                break;
              case 3:
                temp = this.searchFormTemp;
                break;
            }
            this.$RequestUtil.get({
                url: '/api/summary/listSummaryStatus',
                type:'sync',
				params: {
                    pageNum:this.tableCurrentPage,
                    pageSize:10,
                    status :temp.status,
                    startDate :temp.startDate,
                    endDate :temp.endDate,
                    date :temp.date,
                },
                success: (res) => {
                    if(res.code==0){
                        this.tableData = res.data;
                        this.tableTotalPage = res.totalPages;
                        if(res.totalPages == 0&&this.fristLoad){
                            this.$message.warning('查询不到符合条件的数据');
                        }
                        this.fristLoad = true
                    }else{
                        this.$message.error(res.message||res.msg);
                    }
                    
                }
            }); 
        },
        pageChange:function(targetPage){
            this.tableCurrentPage = targetPage;
            this.btnPressType = 3;
            this.search();
        },
        initTable:function(){
            this.search();
        },
        addWindowShow:function(){
            this.addDialogVisible = true;
        },
        showEditDialog:function(rowData){
            this.editDialogVisible = true;
            this.addForm.id = rowData.id
            this.addForm.itemType = rowData.itemType
            this.addForm.materialCode = rowData.materialCode
            this.addForm.specification = rowData.specification
            this.addForm.materialName = rowData.materialName
            this.addForm.unitTypeId = rowData.unitTypeId
        },
        showViewDialog(rowData){
            this.repertTime = null
           this.$RequestUtil.get({
                url: '/api/summary/getSummaryDeatilOfOneMonth',
                type:'sync',
				params: {
                    summaryId:rowData.id
                },
                success:(res)=>{
                    if(res.code==0){
                        this.viewDialogVisible = true
                        this.repertTime =this.parseMonth(rowData)
                        this.detailList = res.data
                    }
                },
           })
        },
        parseCreatDate:function(rowData){
            if(rowData.gmtCreate != null){
                let dateString = commonUtils.timestampToDate(rowData.gmtCreate);
                return dateString;
            }
        },
        parseModifiedDate(rowData){
            if(rowData.gmtModified != null){
                let dateString = commonUtils.timestampToDate(rowData.gmtModified);
                return dateString;
            }
        },
        parseStatus(rowData){
            let str = ''
            if(!rowData.status){
                str = '未汇总'
            }else{
                str = '已汇总'
            }
            return str
        },
        parseMonth(rowData){
            if(rowData.year&&rowData.month){
                let month = ''
                if(rowData.month<10){
                    month = '0'+rowData.month
                }else{
                    month = rowData.month
                }
                
                return `${rowData.year}-${month}`
            }
        },
    }
}
</script>

<style scoped>

.table_searchbar .title11{
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}
.add_form .title{
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    display:inline-block;
    text-align: right;
    width: 70px;
}
.add_form .value{
    display:inline-block
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}

.table_searchbar{
    width:100%;
    margin-top: 10px;
    margin-bottom: 20px;
}
.import_upload{
	display: inline;
}
.page{
    display: flex;
    justify-content: flex-end;
}
@media screen and (max-width: 1450px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }
}
.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}
</style>
<style>
.table_searchbar .el-button--mini, .el-button--mini.is-round {
    padding: 7px 10px;
}
</style>




// WEBPACK FOOTER //
// src/views/stock/MonthlySummary.vue